import { render, staticRenderFns } from "./loader-button.vue?vue&type=template&id=b23093c6&scoped=true"
import script from "./loader-button.vue?vue&type=script&lang=js"
export * from "./loader-button.vue?vue&type=script&lang=js"
import style0 from "./loader-button.vue?vue&type=style&index=0&id=b23093c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23093c6",
  null
  
)

export default component.exports